$slide-transition-time: 300ms;
$image-aspect-ratio-mobile: 1.78;
$slanted-effect-angle: 4deg;

.stage-wrapper {
  position: relative;
  width: 100%;
  overflow: hidden;
  transition: height $slide-transition-time ease;
  margin: 0 auto;
  --slide-max-width: 1920px;

  @include media-max('xxl', false) {
    --slide-max-width: 1440px;
  }

  max-width: var(--slide-max-width);
  clip-path: polygon(0 0, var(--slide-max-width) 0, var(--slide-max-width) calc(100% - var(--slide-max-width) * tan(#{$slanted-effect-angle})), -30px 100%);
  --slanted-effect-height: calc(min(50vw, var(--slide-max-width) / 2) * tan(#{$slanted-effect-angle}));

  .slider-button-container {
    position: absolute;
    top: calc(50vw / $image-aspect-ratio-mobile - var(--slanted-effect-height));
    z-index: 1;

    &--left {
      left: 0;
    }

    &--right {
      right: 0;
    }

    @include media-min('lg') {
      top: calc(50% - var(--slanted-effect-height));
    }
  }

  .slider-button {
    opacity: 0;
    transform: translateY(-50%);
    pointer-events: none;
  }

  @include media-min('md') {
    &:hover,
    &:focus-within {
      .slider-button {
        opacity: 1;
        pointer-events: all;
      }
    }
  }

  @media (hover: hover) {
    &:hover,
    &:focus-within {
      .slider-button {
        opacity: 1;
        pointer-events: all;
      }
    }
  }
}

.slides-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  overflow: hidden;
  touch-action: pan-y;
  transition: transform $slide-transition-time ease;

  &.no-transition {
    transition: none;
  }

  ::slotted(dc-ui-web-stage-item:not(.active)) {
    visibility: hidden !important;
  }

  &.sliding {
    ::slotted(dc-ui-web-stage-item) {
      pointer-events: none;
      visibility: visible !important;
    }
  }
}

.navigation-dots {
  list-style-type: none;
  margin: 16px 0 0;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  li {
    position: relative;
    display: grid;
    place-items: center;
    width: 24px;
    padding: 0;
    aspect-ratio: 1;
    line-height: 0;

    button.dot {
      width: 100%;
      height: 100%;
      margin: 0;
      border: none;
      background: none;
      padding: 0;
      cursor: pointer;
    }

    &::after {
      content: '';
      position: absolute;
      width: 8px;
      aspect-ratio: 1;
      border-radius: 100%;
      background-color: $color-grey-05;
      pointer-events: none;
      transition: all $slide-transition-time;
      opacity: 1;
    }

    &.active {
      width: 28px;

      &::after {
        width: 12px;
        background-color: $color-dark-blue-02;
      }
    }
  }

  &.truncated {
    $num-dots: 3;

    li {
      transition: all $slide-transition-time;
    }

    li:nth-child(#{$num-dots - 1} of .active ~ li),
    li:nth-last-child(#{$num-dots - 1} of :has(~ .active)) {
      &::after {
        opacity: 0.5;
      }
    }

    li:nth-child(#{$num-dots} of .active ~ li),
    li:nth-last-child(#{$num-dots} of :has(~ .active)) {
      &::after {
        opacity: 0.25;
      }
    }

    li:nth-child(#{'n + #{$num-dots + 1} of .active ~ li'}),
    li:nth-last-child(#{'n + #{$num-dots + 1} of :has(~ .active)'}) {
      width: 0;

      &::after {
        opacity: 0;
      }
    }
  }
}
